import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Modal } from 'antd';
import * as settingActions from "~/containers/Settings/actions";
import SettingsVirtualTable from "../../components/SettingsVirtualTable";

var SETTINGS_KEY = 'financeiro.categoria_contas_pagar';

var ContasPagarCategorias = function(props) {
    var addTrigger = props.addTrigger || 0;
    var searchTerm = props.searchTerm || '';
    var categories = useSelector(function(state) { return state.settings[SETTINGS_KEY] || []; });
    var dispatch = useDispatch();

    var sorted = categories.slice().sort(function(a, b) { return (a.value || '').localeCompare(b.value || ''); });
    var columns = [{ key: 'value', title: 'Categoria', render: function(r) { return r.value; } }];

    var handleInlineEdit = function(record, newValue) {
        if (!newValue || !newValue.trim() || newValue.trim() === record.value) return;
        var existing = categories.find(function(i) { return i.value === newValue.trim() && i.id !== record.id; });
        if (existing) {
            Modal.confirm({
                title: "Já existe uma categoria com este nome. Deseja mesclar?",
                content: "Esta ação não poderá ser revertida.",
                okText: "Sim", okType: "danger", cancelText: "Cancelar", zIndex: 1020,
                onOk: function() {
                    dispatch(settingActions.mergeSetting({ data: { key: SETTINGS_KEY, value: newValue.trim() }, id: record.id }));
                },
            });
        } else {
            dispatch(settingActions.updateSetting({ data: { key: SETTINGS_KEY, value: newValue.trim() }, id: record.id }));
        }
    };

    var handleDelete = function(record) {
        dispatch(settingActions.deleteSetting({ id: record.id }));
    };

    var handleQuickAdd = function(value) {
        dispatch(settingActions.createSetting({ data: { key: SETTINGS_KEY, value: value } }));
    };

    return React.createElement(SettingsVirtualTable, {
        data: sorted, columns: columns, searchTerm: searchTerm,
        onInlineEdit: handleInlineEdit,
        onInlineDelete: handleDelete,
        onQuickAdd: handleQuickAdd,
        addTrigger: addTrigger,
        addLabel: 'Nova Categoria',
    });
};

export default ContasPagarCategorias;
